export const inputStringToNumber = (value: string, allowFloat = false): number | undefined => {
  const parser = allowFloat ? parseFloat : (val: string) => parseInt(val, 10);
  const num = parser(value);
  return isNaN(num) ? undefined : num;
};
